import {PortalType} from "@studyportals/domain-client";

export const getPortalTypeFromEnvServer = (): PortalType => {
	const portalTypeStr = process.env.NUXT_PUBLIC_PORTAL_TYPE || 'master';

	const portalTypeMap: Record<string, PortalType> = {
		'master': PortalType.MASTER,
		'bachelor': PortalType.BACHELOR,
		'phd': PortalType.PHD,
		'short': PortalType.SHORT,
		'distance_learning': PortalType.DISTANCE_LEARNING,
	};
	return portalTypeMap[portalTypeStr.toLowerCase()] || PortalType.MASTER;
};
